import React from "react";
import { Chip, makeStyles, Tooltip } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
  chip: {},
  p5: {
    backgroundColor: "#00857A",
    color: "white",
  },
  p4: {
    backgroundColor: "#36b37e",
    color: "white",
  },
  p3: {
    backgroundColor: "#ffab00",
    color: "white",
  },
  p2: {
    backgroundColor: "#ff7452",
    color: "white",
  },
  p1: {
    backgroundColor: "#bf2600",
    color: "white",
  },
}));

const priorityLabels = {
  P5: "Informational",
  P4: "Low",
  P3: "Moderate",
  P2: "High",
  P1: "Critical",
} as Record<string, string>;

export const PriorityChip = ({ priority }: { priority: string }) => {
  const classes = useStyles();
  let chip = <></>;

  switch (priority) {
    case "P5":
      chip = (
        <Chip
          className={clsx(classes.p5, classes.chip)}
          label={priority}
          size="small"
        />
      );
      break;
    case "P4":
      chip = (
        <Chip
          className={clsx(classes.p4, classes.chip)}
          label={priority}
          size="small"
        />
      );
      break;
    case "P3":
      chip = (
        <Chip
          className={clsx(classes.p3, classes.chip)}
          label={priority}
          size="small"
        />
      );
      break;
    case "P2":
      chip = (
        <Chip
          className={clsx(classes.p2, classes.chip)}
          label={priority}
          size="small"
        />
      );
      break;
    case "P1":
      chip = (
        <Chip
          className={clsx(classes.p1, classes.chip)}
          label={priority}
          size="small"
        />
      );
      break;
    default:
      chip = <Chip label={priority} className={classes.chip} size="small" />;
  }

  return <Tooltip title={priorityLabels[priority]}>{chip}</Tooltip>;
};
